import { StructError, create } from 'superstruct';
import { Payload } from './payload';
export { ItemsAddedToCart } from './response';
export const makeAddItemsToCart = function() {
    return async function addItemsToCart(rawPayload) {
        try {
            const payload = create(rawPayload, Payload);
            // Default properties are always injected regardless of feature flag state,
            // so the cart is always consistent and the refresh script doesn't need to
            // process newly added items when flags are off.
            // - _gift_box_parent_id: null — relates to gift wrapping feature
            // - _embroidery_id: null — relates to product embroidering feature
            const defaultAdditionalPropertyValues = {
                _gift_box_parent_id: null,
                _embroidery_id: null,
                _LPROP: null
            };
            const payloadWithAdditionalProperties = {
                ...payload,
                items: payload.items.map((it)=>{
                    const props = it.properties || {};
                    const additionalProps = {
                        ...props
                    };
                    // Embroidery personalization items (those with _embroidery_parent_id) should not
                    // receive _gift_box_parent_id or _embroidery_id defaults.
                    const isEmbroideryPersonalizationItem = Object.prototype.hasOwnProperty.call(additionalProps, '_embroidery_parent_id');
                    const excludeFromEmbroideryPersonalizationItems = new Set([
                        '_gift_box_parent_id',
                        '_embroidery_id'
                    ]);
                    for (const [k, v] of Object.entries(defaultAdditionalPropertyValues)){
                        if (isEmbroideryPersonalizationItem && excludeFromEmbroideryPersonalizationItems.has(k)) {
                            continue;
                        }
                        if (!Object.prototype.hasOwnProperty.call(additionalProps, k)) {
                            additionalProps[k] = v;
                        }
                    }
                    return {
                        ...it,
                        properties: additionalProps
                    };
                })
            };
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payloadWithAdditionalProperties)
            });
            if (!response.ok) {
                const details = await response.json();
                console.warn(details, {
                    payload: rawPayload
                });
                throw new Error(details.description || details.message || 'Cart Error');
            }
            const data = await response.json();
            try {
                if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
                    window.dispatchEvent(new CustomEvent('cart:items-added', {
                        detail: data
                    }));
                }
            } catch (e) {
            // ignore event dispatch errors
            }
            return data;
        } catch (err) {
            if (err instanceof StructError) {
                console.error(err, {
                    payload: rawPayload
                });
                throw new Error('Internal validation error');
            }
            // Re-throw if it's already our custom error from the response handling
            if (err instanceof Error && err.message !== 'Internal error') {
                throw err;
            }
            throw new Error('Internal error');
        }
    };
};
